/** Persisted / display title for new pages and blank labels in the page editor. */
export const UNTITLED_PAGE_LABEL = 'Untitled Page';

/** Snackbar copy after a page is deleted from the report. */
export function getPageDeletedSnackbarText(title: string | undefined): string {
	const name = title?.trim() || UNTITLED_PAGE_LABEL;
	return `"${name}" page has been deleted.`;
}

/** Minimal page representation for the page editor (id + label). */
export interface PageEditorPage {
	id: string;
	label: string;
	icon?: string;
	/** When true, tab is hidden in view mode but shown in edit mode (e.g. drafts). */
	hidden?: boolean;
}

import { randomHex } from '../../../utils/random-hex.util';

/**
 * Returns the default next page to add after the current list.
 * Id format: prefix + hex-like id (e.g. page_d6059e48a6d044a).
 * Use this when handling pageAdded so default title and id pattern live in one place.
 */
export function getDefaultNextPage(
	_currentPages: PageEditorPage[]
): PageEditorPage {
	return {
		id: `page_${randomHex(8)}`,
		label: UNTITLED_PAGE_LABEL,
	};
}
